export default "__VITE_ASSET__BrDV7Sfp__"